// board-bg.js — animated Board Squares background, synced to the live caller game.
//
// RESERVED layer. Mounts only on elements carrying [data-board-bg]; the homepage has
// none (Board Squares collides with the real boards in every product window there), so
// this is a no-op on the homepage and ships ready for the first board-free surface.
//
// On each `bingocall` event (dispatched by the demo engine bridge (or the offline fallback)) it advances a single
// royal "current" cell and accumulates neutral "called" cells, so the field reads as the
// live game playing behind the page. Honors prefers-reduced-motion with a static frame.
(function () {
  var fields = document.querySelectorAll('[data-board-bg]');
  if (!fields.length) return;

  var CELLS = 160;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Build the cell grid once per field.
  for (var f = 0; f < fields.length; f++) {
    var field = fields[f];
    if (field.childElementCount) continue;
    var frag = document.createDocumentFragment();
    for (var n = 0; n < CELLS; n++) frag.appendChild(document.createElement('i'));
    field.appendChild(frag);
  }

  // Scatter calls across the grid deterministically (37 is coprime with 160, so distinct
  // call numbers map to distinct cells — no collisions, stable lighting).
  function cellFor(callNumber) {
    return (callNumber * 37) % CELLS;
  }

  function paint(state) {
    var current = cellFor(state.callNumber || 0);
    var calledCount = (state.called || []).length;
    for (var fi = 0; fi < fields.length; fi++) {
      var cells = fields[fi].children;
      for (var i = 0; i < cells.length; i++) cells[i].className = '';
      for (var c = 0; c < calledCount; c++) {
        var idx = cellFor(c + 1);
        if (cells[idx]) cells[idx].className = 'is-called';
      }
      if (cells[current]) cells[current].className = 'is-current';
    }
  }

  // Initial / reduced-motion static frame: a believable mid-game snapshot.
  paint({ callNumber: 12, called: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11] });
  if (reduced) return;

  document.addEventListener('bingocall', function (e) {
    if (e.detail) paint(e.detail);
  });
})();
